var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "entry-controls" },
    [
      _vm.entry.comment
        ? _c("Button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Посмотреть комментарий",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Посмотреть комментарий',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: { size: "iconic", icon: "comment" },
            on: {
              click: function ($event) {
                return _vm.emitAction("showComment")
              },
            },
          })
        : _vm._e(),
      _c("Button", {
        directives: [
          {
            name: "b-popover",
            rawName: "v-b-popover.html",
            value: {
              container: "#app",
              trigger: "hover blur",
              content: "Посмотреть описание",
              placement: "top",
            },
            expression:
              "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Посмотреть описание',\n      placement: 'top',\n    }",
            modifiers: { html: true },
          },
        ],
        attrs: { disabled: !_vm.entry.item.id, size: "iconic", icon: "file" },
        on: {
          click: function ($event) {
            return _vm.emitAction("showInfo")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }